module.exports = __webpack_public_path__ + "static/media/e62155a8-ef1b-482e-bdad-818f5458024f.c7be5426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/e62155a8-ef1b-482e-bdad-818f5458024f.png
// module id = 1505
// module chunks = 0